import { isAceleresIndividualOwn } from 'dashboard/constants/aceleresConnectionTypes';

const NON_STARTED_LOCK_REASONS = new Set([
  'carteirizado',
  'carteira_reservada',
  'manual_assign',
  'max_cycles_exhausted',
  'manual_assignment_after_exhaustion',
]);

const isTruthy = value =>
  value === true || value === 'true' || value === 1 || value === '1';

export const isAceleresConversationStarted = conversation => {
  const attributes = conversation?.additional_attributes || {};
  const firstReplyCreatedAt = conversation?.first_reply_created_at;

  if (Object.hasOwn(attributes, 'attendance_started')) {
    return isTruthy(attributes.attendance_started);
  }

  if (
    firstReplyCreatedAt &&
    firstReplyCreatedAt !== 0 &&
    firstReplyCreatedAt !== '0'
  ) {
    return true;
  }

  if (!isTruthy(attributes.rodizio_locked)) {
    return false;
  }

  return !NON_STARTED_LOCK_REASONS.has(
    String(attributes.rodizio_locked_reason || '')
  );
};

export const isAceleresPersonalConversation = ({
  conversation = {},
  inbox = {},
} = {}) => {
  const labels = Array.isArray(conversation.labels) ? conversation.labels : [];
  const conversationAttributes = conversation.additional_attributes || {};
  const inboxAttributes =
    inbox.additional_attributes ||
    conversation.inbox?.additional_attributes ||
    {};

  return (
    labels.includes('pessoal') ||
    isAceleresIndividualOwn(inboxAttributes.connection_type) ||
    Number(conversationAttributes.personal_owner_chatwoot_user_id) > 0 ||
    Number(conversationAttributes.personal_origin_chatwoot_user_id) > 0 ||
    Number(conversationAttributes.owner_chatwoot_user_id) > 0
  );
};
